import React from "react";

import queryString from "query-string";
import {decode as base64_decode, encode as base64_encode} from "base-64";
import {ReactSession} from "react-client-session";
import {Helpers} from "../../config/Helpers";
import $ from "jquery";
import {toast} from "react-toastify";

class Details    extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessEmail: (ReactSession.get("sess_email")) ? ReactSession.get("sess_email") : '',
            sessUserType: (ReactSession.get("sess_usertype")) ? ReactSession.get("sess_usertype") : '',
            orderData: '',
            orderDetailsData: [],
            kodeTransaksiOrder: '',
            isModalOutOpen: false,
            isModalReceiveOpen: false,
            urlParam: queryString.parse(window.location.search),
            branchCode: '',
            setModal: '',
            time: {},
            seconds: 0
        }
        this.timer = 0;
    }

    componentDidMount() {
        if(!this.state.sessUserCode){
            window.location.href = './login?redirectUrl=' + base64_encode(window.location.href);
        }else{
            const kodeOrder = (this.state.urlParam.trxid) ? base64_decode(this.state.urlParam.trxid) : '';

            this.setState({
                kodeTransaksiOrder: kodeOrder
            }, () => {
                //console.log(this.state.kodeTransaksiOrder);
                this.showOrder();
            });
        }
    }

    showOrder = () =>{
        Helpers.getListOrder('yes',this.state.kodeTransaksiOrder,'','','').then(res => {
            const status_overall = res[0].status_overall;
            const StatusDirectPayment = res[0].StatusDirectPayment;
            const MetodePembayaran = res[0].MetodePembayaran;
            const SisaWaktuPembayaran = res[0].SisaWaktuPembayaran;
            const SisaWaktuPembayaranSeconds = res[0].SisaWaktuPembayaranSeconds;
            const KodeCabang = res[0].KodeCabang;

            let btn_payment = false;
            let tv_sisa_waktu_bayar = false;
            let tv_sisa_waktu_bayar_view = '';
            let btn_cancel = false;
            let btn_change_payment = '';

            if(status_overall == "Waiting Payment" && StatusDirectPayment == "Pending" && (MetodePembayaran == "Bank" || MetodePembayaran == "e-Money" || MetodePembayaran == "Credit Card" || MetodePembayaran == "Fintech") && parseInt(SisaWaktuPembayaranSeconds) > 0){
                btn_payment = true;
                tv_sisa_waktu_bayar = true;

                this.setState({
                    seconds: parseInt(res[0].SisaWaktuPembayaranSeconds)/1000
                }, () => {
                    let timeLeftVar = this.secondsToTime(this.state.seconds);
                    this.setState({
                        time: timeLeftVar
                    }, () => {
                        this.startTimer();
                    });
                });
            }else if(status_overall == "Waiting Payment" && StatusDirectPayment == "Pending" && (MetodePembayaran == "Bank" || MetodePembayaran == "e-Money" || MetodePembayaran == "Credit Card" || MetodePembayaran == "Fintech") && parseInt(SisaWaktuPembayaranSeconds) == 0){
                btn_payment = false;
                tv_sisa_waktu_bayar = true;
                tv_sisa_waktu_bayar_view = <div>Waktu pembayaran habis, order telah dibatalkan atau dalam proses menunggu konfirmasi pembayaran.</div>
            }else{
                btn_payment = false;
                tv_sisa_waktu_bayar = false;
            }

            if(status_overall == "Order Processed"){
                if(MetodePembayaran == "Bank" || MetodePembayaran == "e-Money" || MetodePembayaran == "Credit Card" || MetodePembayaran == "Fintech"){
                    if(StatusDirectPayment == "Pending" && parseInt(SisaWaktuPembayaranSeconds) > 0){
                        btn_cancel = true;
                        btn_change_payment = <button className="btn btn-fill-out btn-block mr-15" onClick={() => {this.handleChangePaymentMethod()}}>
                            Ubah Pembayaran
                        </button>;
                    }else{
                        btn_cancel = false;
                    }
                }else if(MetodePembayaran == "Saldo"){
                    btn_cancel = false;
                }else{
                    btn_cancel = true;
                }
            }else{
                btn_cancel = false;
            }



            this.setState({
                orderData: res[0],
                btn_payment: btn_payment,
                tv_sisa_waktu_bayar: tv_sisa_waktu_bayar,
                tv_sisa_waktu_bayar_view: tv_sisa_waktu_bayar_view,
                btn_cancel: btn_cancel,
                btn_change_payment: btn_change_payment,
                branchCode: KodeCabang,
                BiayaAdmin: res[0].BiayaAdmin,
                TotalHargaOrder: res[0].TotalHargaOrder,
                GrandTotal: res[0].GrandTotal
            });
        })
    };

    handleCancel = () => {
        if (window.confirm('Apakah anda yakin akan membatalkan order ini?')) {
            Helpers.cancelOrder(this.state.kodeTransaksiOrder, this.state.sessEmail).then(res => {
                if(res.length > 0){
                    if(res[0].alert == 'success'){
                        setTimeout(function() {
                            window.location.href = './account-orders';
                        }, 1000);
                    }

                    toast[res[0].alert](res[0].message);
                }else{
                    toast.error(Helpers.MSG_ERROR);
                }
            })
        }else{
            console.log('Cancel.');
        }
    };

    handlePayment = () => {
        const MetodePembayaran = this.state.orderData.MetodePembayaran;
        const KodePaymentGateway = this.state.orderData.KodePaymentGateway;
        const KodeTransaksiOrder = this.state.orderData.KodeTransaksiOrder;

        if(MetodePembayaran == "Limit"){
            //dialogFormUploadPayment();
        }else if(MetodePembayaran == "Bank" || MetodePembayaran == "e-Money" || MetodePembayaran == "Credit Card" || MetodePembayaran == "Fintech"){
            if(KodePaymentGateway == ""){
                console.log('Empty Payment');
            }else{
                window.location.href = './ppob-payment-details?trxid=' + base64_encode(KodeTransaksiOrder) + '&payment=' + base64_encode(KodePaymentGateway);
            }
        }
    };

    secondsToTime = (secs) => {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    startTimer = () => {
        if (this.timer == 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    countDown = () => {
        let seconds = this.state.seconds - 1;
        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
            tv_sisa_waktu_bayar_view: <div>{((this.state.time.h.toString().length < 2) ? '0'+this.state.time.h : this.state.time.h)}:{((this.state.time.m.toString().length < 2) ? '0'+this.state.time.m : this.state.time.m)}:{((this.state.time.s.toString().length < 2) ? '0'+this.state.time.s : this.state.time.s)}</div>
        });

        if (seconds == 0) {
            clearInterval(this.timer);
            window.location.reload();
        }
    }

    render() {
        return (
            <>
                <main className="main">
                    <div className="page-header breadcrumb-wrap">
                        <div className="container">
                            <div className="breadcrumb">
                                <a href="./" rel="nofollow"><i className="fi-rs-home mr-5"></i>Beranda</a>
                                <span></span> Pembayaran
                            </div>
                        </div>
                    </div>
                    <div className="container mb-80 mt-15">
                        <div className="row">
                            <div className="col-lg-4 m-auto">
                                <div className="border p-md-4 cart-totals ml-30 mb-15">
                                    <div className="table-responsive">
                                        <table className="table no-border" style={{'margin-bottom': '0px'}}>
                                            <tbody>
                                            <tr>
                                                <td className="cart_total_label" colSpan={3}>
                                                    <div className="container-title">
                                                        <div className="title-badge"></div>
                                                        <h6 className="text-muted m-0">Pesanan Diproses</h6>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr align="left">
                                                <td className="image product-thumbnail">
                                                    <div className="icon3"></div>
                                                </td>
                                                <td>
                                                    <small className="text-muted">Kode Order</small>
                                                    <h6 className="text-brand text-align-left">
                                                        {this.state.orderData.KodeTransaksiOrder}
                                                    </h6>
                                                </td>
                                            </tr>

                                            <tr align="left">
                                                <td className="image product-thumbnail">
                                                    <div className="icon4"></div>
                                                </td>
                                                <td>
                                                    <small className="text-muted">Tanggal Beli</small>
                                                    <h6 className="text-brand text-align-left">
                                                        {this.state.orderData.date_d + ' ' + this.state.orderData.date_m  + ' '+  this.state.orderData.date_y + ' ' +  this.state.orderData.date_t  + ' '+ 'WIB'}
                                                    </h6>
                                                </td>
                                            </tr>

                                            <tr align="left">
                                                <td className="image product-thumbnail">
                                                    <div className="icon5"></div>
                                                </td>
                                                <td>
                                                    <small className="text-muted">Pemesan</small>
                                                    <h6 className="text-brand text-align-left">
                                                        {this.state.orderData.NamaWarung}
                                                    </h6>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="border p-md-4 cart-totals ml-30 mb-15">
                                    <div className="table-responsive">
                                        <table className="table no-border">
                                            <tbody>
                                            <tr>
                                                <td className="cart_total_label" colSpan={3}>
                                                    <div className="container-title">
                                                        <div className="title-badge"></div>
                                                        <h6 className="text-muted m-0">Detail Transaksi</h6>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="image product-thumbnail">
                                                    <div className="icon"></div>

                                                </td>
                                                <td>
                                                    <h6 className="text-brand text-align-left">
                                                        {this.state.orderData.CatatanOrder}
                                                    </h6>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="image product-thumbnail">
                                                    <div className="icon1"></div>
                                                </td>
                                                <td>
                                                    <h6 className="text-brand text-align-left">
                                                        {this.state.orderData.DisplayOrderName}
                                                    </h6>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="border p-md-4 cart-totals ml-30 mb-15">
                                    <div className="table-responsive">
                                        <table className="table no-border" style={{'margin-bottom': '0px'}}>
                                            <tbody>
                                            <tr>
                                                <td className="cart_total_label" colSpan={3}>
                                                    <div className="container-title">
                                                        <div className="title-badge"></div>
                                                        <h6 className="text-muted m-0"> Rincian Pembayaran</h6>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr align="left">
                                                <td className="image product-thumbnail">
                                                    <div className="icon5"></div>
                                                </td>
                                                <td>
                                                    <small className="text-muted">Metode</small>
                                                    <h6 className="text-brand text-align-left">
                                                        {this.state.orderData.MetodePembayaran}
                                                    </h6>
                                                </td>
                                            </tr>
                                            <tr align="left">
                                                <td className="image product-thumbnail">
                                                    <div className="icon6"></div>
                                                </td>
                                                <td>
                                                    <small className="text-muted">Status</small>
                                                    <h6 className="text-brand text-align-left">
                                                        {this.state.orderData.StatusPembayaranLabelNew}
                                                    </h6>
                                                </td>
                                            </tr>
                                            <tr align="left">
                                                <td className="image product-thumbnail">
                                                    <div className="icon7"></div>
                                                </td>
                                                <td>
                                                    <small className="text-muted">Sisa Waktu</small>
                                                    <h6 className="text-brand text-align-left">
                                                        {this.state.tv_sisa_waktu_bayar && this.state.tv_sisa_waktu_bayar_view}
                                                    </h6>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="2">
                                                    <div className="divider-2 mt-10 mb-20"></div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="border p-md-4 cart-totals ml-30">
                                    <div className="table-responsive">
                                        <table className="table no-border">
                                            <tbody>
                                            <tr>
                                                <td className="cart_total_label" colSpan={3}>
                                                    <div className="container-title">
                                                        <div className="title-badge"></div>
                                                        <h6 className="text-muted m-0"> Ringkasan Pembayaran</h6>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="cart_total_label">
                                                    <h6 className="text-muted text-align-left">Total Harga </h6>
                                                </td>
                                                <td className="cart_total_amount">
                                                    <h4 className="text-brand text-end">Rp {this.state.TotalHargaOrder}</h4>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="cart_total_label">
                                                    <h6 className="text-muted text-align-left">Biaya Layanan</h6>
                                                </td>
                                                <td className="cart_total_amount">
                                                    <h5 className="text-brand text-end">{this.state.BiayaAdmin}</h5></td>
                                            </tr>
                                            <tr>
                                                <td colSpan="2">
                                                    <div className="divider-2 mt-10 mb-20"></div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td colSpan="2">
                                                    <div className="payment-summary">
                                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                                            <small className="text-muted mb-0">
                                                                Total Pembayaran
                                                            </small>

                                                            <h4 className="text-brand mb-0">
                                                                Rp {this.state.GrandTotal}
                                                            </h4>
                                                        </div>

                                                        <button
                                                            type="button"
                                                            className="btn btn-heading hover-up btn-payment"
                                                            name="bayar"
                                                            onClick={this.handlePayment}
                                                        >
                                                            <i className="fi fi-rs-credit-card mr-10"></i>
                                                            <span>Lanjutkan Pembayaran</span>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </>
        );
    }
}

export default Details;


